import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { ORG_ROLE_DETAILS } from "Constants";
import { OrgRole } from "Types";
import styles from "./selectOrgRole.module.scss";

type SelectRoleProps = {
  name: string;
  readOnly?: boolean;
};

// used to populate the role drop down the in the second column
const SelectRole = ({
  name,
  readOnly = false,
}: SelectRoleProps): React.JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles["select-org-role"]}>
      <Form.Autocomplete
        name={name}
        isReadOnly={readOnly}
        className={getClassName({
          [styles["select-org-role-read-only"]]: readOnly,
        })}
        isClearable={false}
        getOptionLabel={(option) =>
          ORG_ROLE_DETAILS[option as OrgRole]?.label ?? ""
        }
        options={
          Object.keys(ORG_ROLE_DETAILS).filter(
            (role) => role !== "RlSupport",
          ) as OrgRole[]
        }
        errors={errors}
        helperText="Map to Spectra Assure role"
      />
    </div>
  );
};

export default SelectRole;
